import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import { AppStateFacade } from '@app-state';
import {
    PageMetadata,
    PageMetadataRegistry,
} from '@app/router';
import { AccessCode } from '@models';
import { restrictedUrlTree } from '@pages/shared/restricted-access';

@Injectable()
export class LicenseGuard implements CanActivate {
    constructor(
        private _appState: AppStateFacade,
        private _pageRegistry: PageMetadataRegistry,
        private _router: Router,
    ) { }

    canActivate(
        _route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ) {
        const page = this._pageRegistry.findByRoute(state.url);

        if (!this._isFeatureLicensedFor(page)) {
            return restrictedUrlTree(this._router, {
                page,
                code: AccessCode.FeatureNotLicensed,
            });
        }

        return true;
    }

    private _isFeatureLicensedFor(page?: PageMetadata) {
        // if no page was provided, we can't assume it must be licensed
        if (page == null) {
            return true;
        }

        // features are by default licensed
        if (page.licenseFlag == null) {
            return true;
        }

        // no license, no access
        if (this._appState.user.license.value == null) {
            return false;
        }

        return this._appState.user.license.value.features[page.licenseFlag];
    }
}
